import { useState } from "react";
import { FaPlay } from "react-icons/fa";

const Reservation = () => {
  const [showVideoModal, setShowVideoModal] = useState(false);

  return (
    <div className="py-8 px-0">
      <div className="flex flex-col md:flex-row">
        {/* Video Section */}
        <div className="w-full md:w-1/2 relative bg-gray-800 min-h-[400px]">
          <button
            onClick={() => setShowVideoModal(true)}
            className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-yellow-500 rounded-full w-20 h-20 flex items-center justify-center hover:bg-yellow-600 transition-colors duration-300"
          >
            <FaPlay className="text-white text-2xl ml-1" />
          </button>
        </div>

        {/* Booking Form Section */}
        <div className="w-full md:w-1/2 bg-gray-900 flex items-center p-8 md:p-12">
          <div className="w-full">
            <h5 className="text-lg font-medium text-yellow-500 font-serif mb-2">
              Reservation
            </h5>
            <h1 className="text-white text-3xl md:text-4xl font-bold mb-6">
              Book A Table Online
            </h1>

            <form className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="name" className="sr-only">
                    Your Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    placeholder="Your Name"
                    className="w-full px-4 py-3 rounded bg-gray-800 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-500"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="sr-only">
                    Your Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    placeholder="Your Email"
                    className="w-full px-4 py-3 rounded bg-gray-800 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-500"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="datetime" className="sr-only">
                    Date & Time
                  </label>
                  <input
                    type="datetime-local"
                    id="datetime"
                    className="w-full px-4 py-3 rounded bg-gray-800 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-500"
                  />
                </div>
                <div>
                  <label htmlFor="people" className="sr-only">
                    No Of People
                  </label>
                  <select
                    id="people"
                    className="w-full px-4 py-3 rounded bg-gray-800 text-white focus:outline-none focus:ring-2 focus:ring-yellow-500"
                  >
                    <option value="1">People 1</option>
                    <option value="2">People 2</option>
                    <option value="3">People 3</option>
                    <option value="4">People 4</option>
                    <option value="5">People 5+</option>
                  </select>
                </div>
              </div>

              <div>
                <label htmlFor="request" className="sr-only">
                  Special Request
                </label>
                <textarea
                  id="request"
                  rows={4}
                  placeholder="Special Request"
                  className="w-full px-4 py-3 rounded bg-gray-800 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-yellow-500"
                ></textarea>
              </div>

              <button
                type="submit"
                className="w-full bg-yellow-500 hover:bg-yellow-600 text-white font-bold py-3 px-6 rounded transition-colors duration-300"
              >
                BOOK NOW
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Video Modal */}
      {showVideoModal && (
        <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg w-full max-w-4xl">
            <div className="flex justify-between items-center p-4 border-b">
              <h3 className="text-xl font-bold">Youtube Video</h3>
              <button
                onClick={() => setShowVideoModal(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                &times;
              </button>
            </div>
            <div className="aspect-w-16 aspect-h-9">
              <iframe
                src="https://www.youtube.com/embed/DWRcNpR6Kdc"
                className="w-full h-[400px] md:h-[500px]"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Reservation;
